import React from 'react';

import { Box, LinearProgress, SxProps } from '@mui/material';

import { assetUrl } from '../../helpers/assetUrl';

const getStyles = (): { [key: string]: SxProps } => {
  return {
    root: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& .logo': {
        position: 'relative',
        width: 70,
        '& img': {
          display: 'block',
          marginTop: '6px',
        },

        '& .progress-container': {
          position: 'absolute',
          bottom: -10,
          width: '100%',
        },
      },
    },
  };
};

export const SplashScreen = React.memo(() => {
  const styles = getStyles();
  return (
    <Box sx={styles.root}>
      <div className="logo">
        <img width="70" src={`${assetUrl('/images/logos/logo-ico.svg')}`} alt="Tertius" />
        <div className="progress-container">
          <LinearProgress color="secondary" />
        </div>
      </div>
    </Box>
  );
});
